/**
 * Costura entre o splash NATIVO e a primeira tela web.
 *
 * ── A sequência que não pode piscar ─────────────────────────────────────────
 *   1. Splash nativo (imagem sobre `#f4f1ec`).
 *   2. WebView pinta o `index.html` — que no build mobile já carrega o
 *      `#boot-placeholder`: mesmo papel, mesma marca. Ver `mobile-postbuild.mjs`.
 *   3. `hideNativeSplash()` — a troca é invisível porque os dois lados desenham
 *      a mesma coisa.
 *   4. React monta a `BootScreen` (idem) e `clearBootPlaceholder()` tira o
 *      HTML estático de baixo.
 *
 * O flash aparecia entre 1 e 2: `launchShowDuration: 0` derrubava o splash na
 * hora e por baixo não havia nada além do fundo.
 *
 * ⚠️ **O teto do splash fica no `launchShowDuration`, não aqui.** Se o bundle
 * quebrar, este módulo nunca roda — e com `launchAutoHide: false` o app ficaria
 * preso no splash para sempre, um travamento pior que o que estamos
 * consertando. Com o teto, o splash sai sozinho e revela o placeholder HTML,
 * que não depende de JavaScript nenhum.
 */

import { isNativeApp } from "../platform/native";
import { bootMark } from "./bootTrace";

/** Remove o placeholder estático. Idempotente: na web não existe e é no-op. */
export function clearBootPlaceholder(): void {
  const el = document.getElementById("boot-placeholder");
  if (!el) return;
  el.remove();
  bootMark("placeholder", "ok", "removido");
}

/**
 * Esconde o splash nativo. Import dinâmico para o bundle web não carregar o
 * plugin — na web esta função retorna antes de tocar nele.
 */
export async function hideNativeSplash(): Promise<void> {
  if (!isNativeApp()) return;
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
    bootMark("splash", "ok", "escondido");
  } catch (err) {
    // Plugin ausente ou bridge indisponível não pode derrubar o boot: o
    // `launchShowDuration` já garante que o splash sai sozinho.
    bootMark("splash", "fail", err instanceof Error ? err.message : String(err));
  }
}
